import "./src/styles/global.css";

export const onRouteUpdate = () => {
  const executeScrollLogic = () => {
    const headers = document.querySelectorAll(
      ".content h1, .content h2, .content h3, .content h4, .content h5, .content h6"
    ); // Adjust selector as needed
    const links = document.querySelectorAll("#table-of-contents a"); // Adjust selector as needed

    window.addEventListener("scroll", () => {
      let fromTop = window.scrollY + 200; // Adjust 250 to account for any fixed header, etc.
      
      headers.forEach((header, index) => {
        if (header.offsetTop <= fromTop) {
          links.forEach((e, t) => {
            e.classList.remove("active");
          });
          links[index].classList.add("active");
        }
      });
    });
  };

  // Ensure that the DOM is fully loaded before executing the script
  if (document.readyState === "complete") {
    executeScrollLogic();
  } else {
    window.onload = executeScrollLogic;
  }

  window.onscroll = () => {
    var winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    var height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    var myBar = document.getElementById("myBar");
    if (myBar) {
      myBar.style.width = scrolled + "%";
    }

    const sticker = document.querySelector("#sticker");
    if (sticker) {
        sticker.classList.remove("hidden");
        if (winScroll < 200) {
            sticker.classList.add("hidden");
        }
    }
  };
};
